import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PageView } from 'app/views';

export default () => {
  const page = useSelector((state) => state.page);
  return useMemo(() => new PageView(page), [page.status]);
};
